import {useState} from "react";
import styled from 'styled-components/macro';

import {
    Button,
    FormControl,
    FormHelperText,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    useToast
} from "@chakra-ui/react";
import {useFeedback} from "../store/feedback";
import {useSaveToFolder} from "../api/save";

const AddFolder = styled(({post, comment, onClose}) => {
    const {feedbackCh} = useFeedback();
    const toast = useToast();
    const author = post ? post.author : comment.author;
    const id = post ? post.id : comment.id;
    const [content, setContent] = useState('');
    const save = useSaveToFolder(feedbackCh);
    const handleSaveToNewFolder = async (event) => {
        onClose();
        try {
            save(id, post ? 'true' : 'false', content);
            toast({
                title: `This post has been saved.`,
                status: 'success',
                isClosable: true,
            })
        } catch {
            // toast.error("Failed to save post.");
        }
    };
    return (
        <Modal
            isOpen
            onClose={onClose}
            size={'lg'}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Create a new folder</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <Stack spacing={'5'}>

                        <FormControl>
                            <FormLabel>Name</FormLabel>
                            <Input placeholder="Memes" value={content}
                                      onChange={(e) => setContent(e.currentTarget.value)}/>
                            <FormHelperText>u/{author}'s post will be added to this folder.</FormHelperText>
                        </FormControl>

                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>
                    <Button variant="blue" onClick={handleSaveToNewFolder}>Save</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )})``;

export default AddFolder;
